import { CommonModule } from "@angular/common";
import { NgModule, inject } from "@angular/core";
import { SwiperModule } from "swiper/angular";

import {
    svgArrowLeft,
    svgArrowRight,
    SvgIconComponent,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";

import { MediaCtaComponent } from "@hermes/media-cta";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { CHAPTERS_COMPONENT } from "../../core";
import { AnimateOnScrollDirectiveModule } from "../../directives/animate-on-scroll/animate-on-scroll.module";

import { GalleryCarouselAnalyticsService } from "./gallery-carousel-analytics.service";
import { GalleryCarouselComponent } from "./gallery-carousel.component";

@NgModule({
    imports: [
        CommonModule,
        AnimateOnScrollDirectiveModule,
        SwiperModule,
        SvgIconComponent,
        SrOnlyNoSnippetDirective,
        MediaCtaComponent,
    ],
    declarations: [GalleryCarouselComponent],
    providers: [
        GalleryCarouselAnalyticsService,
        {
            provide: CHAPTERS_COMPONENT,
            useValue: GalleryCarouselComponent,
        },
    ],
})
export class GalleryCarouselModule {
    constructor() {
        const svgRegistryService = inject(SvgRegistryService);

        svgRegistryService.registerSvgs([svgArrowLeft, svgArrowRight]);
    }
}
